import React from "react";
import PropTypes from "prop-types";

import Select from "react-select";
import TypesUtils from "../../inumet_js_lib/utils/typesUtils";
import Colors from "../../res/colors/colors";
import FormElement from "../forms/formElement"

const DEFAULT_PLACEHOLDER = "Seleccione una opción";

const groupStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const groupBadgeStyles = {
  backgroundColor: "#EBECF0",
  borderRadius: "2em",
  color: "#172B4D",
  display: "inline-block",
  fontSize: 12,
  fontWeight: "normal",
  lineHeight: "1",
  minWidth: 1,
  padding: "0.16666666666667em 0.5em",
  textAlign: "center",
};

const groupLabelStyle = {
  color: "#172B4D",
  fontSize: 14,
  fontWeight: "bold",
};

class Selector extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: undefined };
    this.selectRef = React.createRef();
  }

  formatGroupLabel(data) {
    return (
      <div style={groupStyles}>
        <span style={groupLabelStyle}>{data.label}</span>
        <span style={groupBadgeStyles}>{data.options.length}</span>
      </div>
    );
  }

  render() {
    // Fix para evitar overlaping del dropdown
    const selectStyles = {
      control: (base, state) => {
        let propsErr = {};
        if (state.selectProps.errorText) {
          // "state.selectProps" references the component props
          propsErr = {
            boxShadow: `0 0 0 2px ${Colors.error}`,
            transition: " 0.25s linear",
            transitionProperty: "box-shadow",
          };
        }
        return {
          ...base,
          //       height: "34px",
          //       minHeight: "34px",
          ...propsErr,
        };
      },
      menu: (styles) => ({ ...styles, zIndex: 999 }),
    };
    let defaultValue = null;
    let formatGroupLabelFunc = null;
    let placeholder = "Cargando...";
    if (!this.props.loading) {
      formatGroupLabelFunc = null;
      if (this.props.grouped) {
        formatGroupLabelFunc = this.formatGroupLabel;
      }
      if (this.props.isDisabled) {
        placeholder = this.props.placeholderDisabled
          ? this.props.placeholderDisabled
          : "";
      } else if (
        this.props.options.length === 0 &&
        this.props.placeholderNoItems
      ) {
        placeholder = this.props.placeholderNoItems;
      } else {
        placeholder = this.props.placeholder
          ? this.props.placeholder
          : DEFAULT_PLACEHOLDER;
      }
      if (
        this.props.defaultValueIndex >= 0 &&
        this.props.options &&
        this.props.options.length > this.props.defaultValueIndex
      ) {
        defaultValue = this.props.options[this.props.defaultValueIndex];
      } else if (this.props.defaultValue) {
        if (TypesUtils.isObject(this.props.defaultValue))
          defaultValue = this.props.defaultValue;
        else {
          // Si default value no es un objeto, puede ser un valor que coincida con el atributo
          // value de alguno de los items
          defaultValue = this.props.options.some((item) => {
            return item.value === this.props.defaultValue;
          });
        }
      }
    }
    let selector = (
      <Select
        styles={selectStyles}
        isLoading={this.props.loading}
        onChange={(value) => {
          this.setState({ value });
          this.props.onSelect(value);
        }}
        value={this.state.value ? this.state.value : defaultValue}
        options={this.props.options}
        placeholder={placeholder}
        formatGroupLabel={formatGroupLabelFunc}
        noOptionsMessage={() => "No hay opciones disponibles"}
        isClearable={this.props.isClearable}
        errorText={this.props.errorText}
        isDisabled={this.props.isDisabled}
        isInvalid={true}
        isSearchable={ false }
      />
    );

    return (
      <FormElement
        labelStyle={this.props.labelStyle}
        label={this.props.label}
        loading={this.props.loading}
        helpText={this.props.helpText}
        mt={this.props.mt}
        mr={this.props.mr}
        ml={this.props.ml}
        mb={this.props.mb}
        isDisabled={this.props.isDisabled}
        errorText={this.props.errorText}
        id={this.props.id}
      >
        {selector}
      </FormElement>);
  }
}

function createOption(value, label) {
  return { value, label };
}

Selector.propTypes = {
  defaultValueIndex: PropTypes.number,
  defaultValue: PropTypes.object,
  placeholder: PropTypes.string,
  placeholderDisabled: PropTypes.string,
  placeholderNoItems: PropTypes.string,
  grouped: PropTypes.bool,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.arrayOf(PropTypes.string),
  ]),
  onSelect: PropTypes.func,
  formGroup: PropTypes.bool,
  labelStyle: PropTypes.object,
  label: PropTypes.string,
  loading: PropTypes.bool,
  isClearable: PropTypes.bool,
  helpText:PropTypes.string,
  mt: PropTypes.number,
  mr: PropTypes.number,
  ml: PropTypes.number,
  mb: PropTypes.number,
  isDisabled: PropTypes.bool,
  errorText: PropTypes.string,
  id:PropTypes.string,
};

export { Selector as default, createOption };
